import dayjs from 'dayjs'
import {
  RateType,
  type PaymentCard
} from '../hooks/usePaymentCards'

export function mapFormToPublishedOnlyCard<T extends { _id?: string; initialId?: string }>(
  formCard: T,
  previousVersion: PaymentCard
) {
  const effectiveDateTime = previousVersion.effectiveFrom
    ? dayjs(previousVersion.effectiveFrom)
    : undefined

  return {
    ...formCard,
    name: previousVersion.name,
    effectiveDate: effectiveDateTime,
    effectiveTime: effectiveDateTime,
    previousVersion: undefined,
    plannedUpdateRemoved: true,
    teamMembers: previousVersion.teamMembers ?? [],
    rates: previousVersion.rates.map((entry) => ({
      ...entry,
      rate: parseFloat(entry.rate) || 0,
      rateType: entry.rateType || RateType.HOURLY
    }))
  }
}
